import React from 'react';
import { Link } from 'react-router-dom';
import { usePermissions } from '../../../Services/PermissionsContext'; // Import the permissions context
import { hasPermission } from '../../../Services/checkPermissions';   // Import the helper function

const TabMenu = ({ name }) => {
    const permissions = usePermissions(); // Get global permissions
    if (permissions.length === 0) {
        return <div>No permissions available</div>; // Handle case when there are no permissions
    }

    return (
        <div className='management-tabs'>
            <ul className='management-tablinks'>
               {hasPermission(permissions, 'samplecollection', 'view') && 
                    <li className={`action-item ${name === 'samplecollection' ? 'active-tab' : ''}`}>
                        <Link to="/admin/delivery-management/samplecollection">Sample Collection</Link>
                    </li>
                }
                {hasPermission(permissions, 'completed-orders', 'view') && 
                <li className={`action-item ${name === 'completed-orders' ? 'active-tab' : ''}`}>
                    <Link to="/admin/delivery-management/completed-orders">Completed Orders</Link>
                </li>
                }

            </ul>
        </div>
    );
};

export default TabMenu;
